import { render } from "./viewContent.vue?vue&type=template&id=361baf36&scoped=true"
import script from "./viewContent.vue?vue&type=script&lang=js"
export * from "./viewContent.vue?vue&type=script&lang=js"

import "./viewContent.vue?vue&type=style&index=0&id=361baf36&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361baf36"]])

export default __exports__